import { setFulfilled, setPending, setRejected } from '@ms/yammer-data-support';
import { Reducer } from 'redux';

import { NetworkQuestionInfoPanelLoadAction } from '../../domains/networkQuestionInfoPanel/actions.types';
import { NetworkQuestionInfoPanelEditAction } from '../../domains/networkQuestionInfoPanel/editActions.types';

import { NetworkQuestionInfoPanelLifecycle } from './types';

const initialState: NetworkQuestionInfoPanelLifecycle = {
  pending: false,
  fulfilled: undefined,
  rejected: undefined,
};

export type NetworkQuestionInfoPanelActions = NetworkQuestionInfoPanelLoadAction | NetworkQuestionInfoPanelEditAction;

const reducer: Reducer<NetworkQuestionInfoPanelLifecycle, NetworkQuestionInfoPanelActions> = (
  state = initialState,
  action
) => {
  switch (action.type) {
    case 'NETWORK_QUESTION_INFO_PANEL.LOAD_FULFILLED':
      return setFulfilled(action.payload);
    case 'NETWORK_QUESTION_INFO_PANEL.LOAD_PENDING':
      return setPending();
    case 'NETWORK_QUESTION_INFO_PANEL.LOAD_REJECTED':
      return setRejected(action.payload.error);
    case 'NETWORK_QUESTION_INFO_PANEL.EDIT_FULFILLED':
      return setFulfilled({
        ...action.payload,
        viewerCanEditNetworkQuestionInfoPanel: state.fulfilled?.viewerCanEditNetworkQuestionInfoPanel || false,
      });
    default:
      return state;
  }
};

export default reducer;
